import Vue from 'vue'
import Router from 'vue-router'
import Details from '@/components/details'
import Home from '../components/home'
import Main from '../components/main'
import Update from '../components/update'
import ImgUpdate from '../components/imgupdate'
import SurveyForm from '../components/surveyform'
import SurveyForm_house from '../components/surveyform-house'
import SurveyForm_windows from '../components/surveyform-windows'
import SurveyForm_toilet from '../components/surveyform-toilet'
import SurveyForm_1 from '../components/surveyform-1'
import Login from '../components/login'
import PasswordReset from '../components/password-reset'
import PasswordSms from '../components/password-sms'
import store from '../store/store'

import Message from '../components/message'
import Takeorder from '../components/takeorder'
import Account from '../components/account'
import Profile from '../components/profile'
import Search from '../components/search'
import Contract from '../components/contract'
import ContractFile from '../components/contractFile'
import ContractDetail from '../components/contractDetail'
import ContractModify from '../components/contractModify'
import Bookservice from '../components/bookservice'
import BookserviceWx from '../components/bookserviceWx'
import Order from '../components/order'
import OrderDetail from '../components/orderDetail'
import Avatar from '../components/avatar'
import Guarante from '../components/guarante'
import GuaranteDetail from '../components/guaranteDetail'
import Invoice from '../components/invoice'
import InvoiceDetail from '../components/invoiceDetail'
import CustomerDetail from '../components/customerDetail'
import ReportOrder from '../components/reportOrder'
import Procedure from '../components/procedure'
import ProcedureActivation from '../components/procedureActivation'
import Test from '../components/test'
import WxTest from '../components/wxTest'
//留资页
import DeclarationForm from "../components/declarationForm"

import * as types from '../store/types'
import Construc1 from '../components/construction-1'
import Construc2 from '../components/construction-2'
import Construc3 from '../components/construction-3'
import Construc4 from '../components/construction-4'
import Construc5 from '../components/construction-5'
import Construc6 from '../components/construction-6'

import Newstep_1_1 from '../components/newstep-1-1'
import Newstep_1_8910 from '../components/newstep-1-8910'
import Newstep_2_1 from '../components/newstep-2-1'
import Newstep_2_2 from '../components/newstep-2-2'
import Newstep_2_345 from '../components/newstep-2-345'
import Newstep_2_891011 from '../components/newstep-2-891011'
import Newstep_3_1 from '../components/newstep-3-1'
import Newstep_3_6 from '../components/newstep-3-6'
import Newstep_3_7 from '../components/newstep-3-7'
import Newstep_3_8 from '../components/newstep-3-8'
import Newstep_3_11 from '../components/newstep-3-11'
import Newstep_3_12 from '../components/newstep-3-12'
import Newstep_3_910 from '../components/newstep-3-910'
import Newstep_4_1 from '../components/newstep-4-1'
import Newstep_4_45 from '../components/newstep-4-45'
import Newstep_4_6 from '../components/newstep-4-6'
import Newstep_4_7 from '../components/newstep-4-7'
import Newstep_4_910 from '../components/newstep-4-910'
import Newstep_5_1 from '../components/newstep-5-1'
import Newstep_5_6 from '../components/newstep-5-6'
import Newstep_5_8 from '../components/newstep-5-8'
import Newstep_5_12 from '../components/newstep-5-12'
import Newstep_5_711 from '../components/newstep-5-711'
import Newstep_5_910 from '../components/newstep-5-910'
import Newstep_6_2 from '../components/newstep-6-2'
import Newstep_6_3 from '../components/newstep-6-3'
import Newstep_6_4 from '../components/newstep-6-4'
import Newstep_6_5 from '../components/newstep-6-5'
import Newstep_6_12 from '../components/newstep-6-12'
import Newstep_6_910 from '../components/newstep-6-910'
import Newstep_7_6 from '../components/newstep-7-6'
import Newstep_7_8 from '../components/newstep-7-8'
import Newstep_7_12 from '../components/newstep-7-12'
import Newstep_8_8 from '../components/newstep-8-8'
import Newstep_9_8 from '../components/newstep-9-8'
import Newstep_10_9 from '../components/newstep-10-9'
import Newstep_10_10 from '../components/newstep-10-10'
import Newstep_11_10 from '../components/newstep-11-10'
import Newstep_12_10 from '../components/newstep-12-10'
import Newstep_13_10 from '../components/newstep-13-10'
import personalinfo from '../components/personalinfo'
import custInfoSource from '../components/custInfoSource'

Vue.use(Router);
const routes = [{
    path: '/',
    component: Login
  },
  {
    path: '/login',
    // name:'login',
    component: Login
  },
  {
    path: '/password-reset',
    name: 'password-reset',
    component: PasswordReset
  },
  {
    path: '/password-sms',
    name: 'password-sms',
    component: PasswordSms
  },
  {
    path: '/test',
    name: 'test',
    component: Test
  },
  {
    path: '/wxTest',
    name: 'wxTest',
    component: WxTest
  },
  {
    path: '/declarationForm',
    name: 'declarationForm',
    component: DeclarationForm,
    meta: {
      title: '雨虹防水维修服务'
    }
  },
  {
    path: '/surveyform',
    name: 'surveyform',
    meta: {
      requireAuth: true
    },
    component: SurveyForm
  }, {
    path: '/surveyform-house',
    name: 'surveyform-house',
    meta: {
      requireAuth: true
    },
    component: SurveyForm_house
  }, {
    path: '/surveyform-windows',
    name: 'surveyform-windows',
    meta: {
      requireAuth: true
    },
    component: SurveyForm_windows
  }, {
    path: '/surveyform-toilet',
    name: 'surveyform-toilet',
    meta: {
      requireAuth: true
    },
    component: SurveyForm_toilet
  },
  {
    path: '/surveyform-1',
    name: 'surveyform-1',
    meta: {
      requireAuth: true
    },
    component: SurveyForm_1
  },
  {
    path: '/construction-2',
    name: 'construction-2',
    meta: {
      requireAuth: true
    },
    component: Construc2
  },
  {
    path: '/construction-1',
    name: 'construction-1',
    meta: {
      requireAuth: true
    },
    component: Construc1
  },
  {
    path: '/construction-4',
    name: 'construction-4',
    meta: {
      requireAuth: true
    },
    component: Construc4
  },
  {
    path: '/construction-5',
    name: 'construction-5',
    meta: {
      requireAuth: true
    },
    component: Construc5
  },
  {
    path: '/construction-6',
    name: 'construction-6',
    meta: {
      requireAuth: true
    },
    component: Construc6
  },
  {
    path: '/construction-3',
    name: 'construction-3',
    meta: {
      requireAuth: true
    },
    component: Construc3
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile
  },
  {
    path: '/avatar',
    name: 'avatar',
    component: Avatar
  },
  {
    path: '/guarante',
    name: 'guarante',
    component: Guarante
  },
  {
    path: '/guaranteDetail',
    name: 'guaranteDetail',
    component: GuaranteDetail
  },
  {
    path: '/invoice',
    name: 'invoice',
    component: Invoice
  },
  {
    path: '/invoiceDetail',
    name: 'invoiceDetail',
    component: InvoiceDetail
  },
  {
    path: '/customerDetail',
    name: 'customerDetail',
    component: CustomerDetail
  },
  {
    path: '/reportOrder',
    name: 'reportOrder',
    component: ReportOrder
  },
  {
    path: '/procedure',
    name: 'procedure',
    component: Procedure
  },
  {
    path: '/procedureActivation',
    name: 'procedureActivation',
    component: ProcedureActivation
  },
  {
    path: '/main',
    name: 'home',
    // meta:{requireAuth: true},
    component: Home,
    children: [{
        path: '/main',
        name: 'main',
        component: Main
      },
      {
        path: '/order',
        name: 'order',
        component: Order
      },
      {
        path: '/message',
        name: 'message',
        component: Message
      },
      {
        path: '/account',
        name: 'account',
        component: Account
      },
      {
        path: '/imgupdate',
        name: 'imgupdate',
        component: ImgUpdate
      },
      {
        path: '/contract',
        name: 'contract',
        component: Contract
      },
      {
        path: '/contractFile',
        name: 'contractFile',
        component: ContractFile
      },
    ]
  },
  {
    path: '/update',
    name: 'update',
    component: Update
  },
  {
    path: '/details',
    name: 'details',
    component: Details
  },
  {
    path: '/takeorder',
    name: 'takeorder',
    component: Takeorder
  },
  {
    path: '/search',
    name: 'search',
    component: Search
  },
  {
    path: '/bookservice',
    name: 'bookservice',
    component: Bookservice
  },
  {
    path: '/bookserviceWx',
    name: 'bookserviceWx',
    component: BookserviceWx
  },
  {
    path: '/contractDetail',
    name: 'contractDetail',
    component: ContractDetail
  },
  {
    path: '/contractModify',
    name: 'contractModify',
    component: ContractModify
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: OrderDetail
  },
  {
    path: "/newstep-1-1",
    name: "newstep-1-1",
    component: Newstep_1_1
  },
  {
    path: "/newstep-1-8910",
    name: "newstep-1-8910",
    component: Newstep_1_8910
  },
  {
    path: "/newstep-2-1",
    name: "newstep-2-1",
    component: Newstep_2_1
  },
  {
    path: "/newstep-2-2",
    name: "newstep-2-2",
    component: Newstep_2_2
  },
  {
    path: "/newstep-2-345",
    name: "newstep-2-345",
    component: Newstep_2_345
  },
  {
    path: "/newstep-2-891011",
    name: "newstep-2-891011",
    component: Newstep_2_891011
  },
  {
    path: "/newstep-3-1",
    name: "newstep-3-1",
    component: Newstep_3_1
  },
  {
    path: "/newstep-3-6",
    name: "newstep-3-6",
    component: Newstep_3_6
  },
  {
    path: "/newstep-3-7",
    name: "newstep-3-7",
    component: Newstep_3_7
  },
  {
    path: "/newstep-3-8",
    name: "newstep-3-8",
    component: Newstep_3_8
  },
  {
    path: "/newstep-3-11",
    name: "newstep-3-11",
    component: Newstep_3_11
  },
  {
    path: "/newstep-3-12",
    name: "newstep-3-12",
    component: Newstep_3_12
  },
  {
    path: "/newstep-3-910",
    name: "newstep-3-910",
    component: Newstep_3_910
  },
  {
    path: "/newstep-4-1",
    name: "newstep-4-1",
    component: Newstep_4_1
  },
  {
    path: "/newstep-4-45",
    name: "newstep-4-45",
    component: Newstep_4_45
  },
  {
    path: "/newstep-4-6",
    name: "newstep-4-6",
    component: Newstep_4_6
  },
  {
    path: "/newstep-4-7",
    name: "newstep-4-7",
    component: Newstep_4_7
  },
  {
    path: "/newstep-4-910",
    name: "newstep-4-910",
    component: Newstep_4_910
  },
  {
    path: "/newstep-5-1",
    name: "newstep-5-1",
    component: Newstep_5_1
  },
  {
    path: "/newstep-5-6",
    name: "newstep-5-6",
    component: Newstep_5_6
  },
  {
    path: "/newstep-5-8",
    name: "newstep-5-8",
    component: Newstep_5_8
  },
  {
    path: "/newstep-5-12",
    name: "newstep-5-12",
    component: Newstep_5_12
  },
  {
    path: "/newstep-5-711",
    name: "newstep-5-711",
    component: Newstep_5_711
  },
  {
    path: "/newstep-5-910",
    name: "newstep-5-910",
    component: Newstep_5_910
  },
  {
    path: "/newstep-6-2",
    name: "newstep-6-2",
    component: Newstep_6_2
  },
  {
    path: "/newstep-6-3",
    name: "newstep-6-3",
    component: Newstep_6_3
  },
  {
    path: "/newstep-6-4",
    name: "newstep-6-4",
    component: Newstep_6_4
  },
  {
    path: "/newstep-6-5",
    name: "newstep-6-5",
    component: Newstep_6_5
  },
  {
    path: "/newstep-6-12",
    name: "newstep-6-12",
    component: Newstep_6_12
  },
  {
    path: "/newstep-6-910",
    name: "newstep-6-910",
    component: Newstep_6_910
  },
  {
    path: "/newstep-7-6",
    name: "newstep-7-6",
    component: Newstep_7_6
  },
  {
    path: "/newstep-7-8",
    name: "newstep-7-8",
    component: Newstep_7_8
  },
  {
    path: "/newstep-7-12",
    name: "newstep-7-12",
    component: Newstep_7_12
  },
  {
    path: "/newstep-8-8",
    name: "newstep-8-8",
    component: Newstep_8_8
  },
  {
    path: "/newstep-9-8",
    name: "newstep-9-8",
    component: Newstep_9_8
  },
  {
    path: "/newstep-10-9",
    name: "newstep-10-9",
    component: Newstep_10_9
  },
  {
    path: "/newstep-10-10",
    name: "newstep-10-10",
    component: Newstep_10_10
  },
  {
    path: "/newstep-11-10",
    name: "newstep-11-10",
    component: Newstep_11_10
  },
  {
    path: "/newstep-12-10",
    name: "newstep-12-10",
    component: Newstep_12_10
  },
  {
    path: "/newstep-13-10",
    name: "newstep-13-10",
    component: Newstep_13_10
  },
  {
    path: "/personalinfo",
    name: "personalinfo",
    component: personalinfo
  },
  {
    path: "/custinfosource",
    name: "custinfosource",
    component: custInfoSource
  }
];

const router = new Router({
  routes
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js